<template lang="pug">
  v-card
    v-card-title
      h2.modal-title {{ 'modals.blank_edit' | translate }}
    v-card-content
      .cols-x
        .cols-x__2
          v-text-field.mb-3(
            :label="$t('base.farm_name')"
            v-model="currentAdditional.name")
        .cols-x__2
          v-text-field.mb-3(
            :label="$t('base.struct_manager')"
            v-model="currentAdditional.structure_manager")
      .cols-x
        .cols-x__2
          v-text-field.mb-3(
            :label="$t('base.company')"
            v-model="currentAdditional.company_name")
        .cols-x__2
          v-text-field.mb-3(
            :label="$t('base.farm_manager')"
            v-model="currentAdditional.farm_manager")
      .cols-x
        .cols-x__2
          v-text-field.mb-3(
            :label="$t('base.ind_code')"
            v-model="currentAdditional.ind_code")
        .cols-x__2
          v-text-field.mb-3(
            :label="$t('base.zootechnic')"
            v-model="currentAdditional.zootechnics")
      .cols-x
        .cols-x__2
          v-text-field.mb-3(
            :label="$t('base.struct')"
            v-model="currentAdditional.structure_name")
        .cols-x__2
           v-text-field.mb-3(
             :label="$t('base.accountant')"
             v-model="currentAdditional.accountant")
      .cols-x
        .cols-x__2
          v-text-field.mb-3(
            :label="$t('base.farm')"
            v-model="currentAdditional.farm_full_name")
        .cols-x__2
           v-text-field(
             :label="$t('base.weigher')"
             v-model="currentAdditional.weigher")
      v-text-field(
        :label="$t('base.destination')"
        v-model="currentAdditional.appoint")
    v-card-actions
      v-btn(
        :loading="loading"
        @click="onUpdate") {{ 'base.save' | translate }}
      delete-btn(
        @delete="onDelete")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'EditModal',

  components: {
    DeleteBtn
  },

  data: () => ({
    loading: false
  }),

  computed: {
    ...mapGetters('additional', [
      'currentAdditional'
    ])
  },

  methods: {
    ...mapActions('additional', [
      'saveAdditional',
      'deleteAdditional'
    ]),

    async onUpdate () {
      this.loading = true
      const error = await this.saveAdditional()
      this.loading = false
      if (!error) {
        this.$emit('close')
      } else {
        this.$toasted.error(this.$t('errors.incorrect_data'))
      }
    },

    async onDelete () {
      await this.deleteAdditional()
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
  display: flex;
  gap: 1rem;
}

.v-card__actions button:first-child {
  flex-basis: 48%;
}
</style>
